import React, { type ComponentPropsWithoutRef, type ReactNode } from 'react';
import { m } from 'framer-motion';
import classNames from 'classnames';
import { useNavigationContext } from './NavigationProvider';
import styles from './styles.module.scss';
const animations = {
  back: {
    initial: {
      y: '-100%'
    },
    exit: {
      y: '100%'
    }
  },
  forward: {
    initial: {
      y: '100%'
    },
    exit: {
      y: '-100%'
    }
  }
};
type MotionDivProps = ComponentPropsWithoutRef<typeof m.div>;
export type StepWrapperProps = Omit<MotionDivProps, 'children'> & {
  bgColor: 'white' | 'mint';
  children?: ReactNode;
  gutter?: 'wide' | 'narrow' | 'xnarrow' | 'none';
};
export const StepWrapper = ({
  children,
  bgColor,
  gutter = 'wide',
  ...rest
}: StepWrapperProps) => {
  const {
    navigationDirection
  } = useNavigationContext();
  const animation = animations[navigationDirection];
  return <m.div initial={animation.initial} animate={{
    y: '0'
  }} exit={animation.exit} transition={{
    duration: 0.4
  }} className={classNames(styles.stepWrapper, {
    [styles.mint]: bgColor === 'mint',
    [styles.gutterWide]: gutter === 'wide',
    [styles.gutterNarrow]: gutter === 'narrow',
    [styles.gutterXNarrow]: gutter === 'xnarrow',
    [styles.gutterNone]: gutter === 'none'
  })} {...rest}>
      {children}
    </m.div>;
};